import { camelOrderDeliveryForm } from '@/pages/camel-order/delivery/service';
import { FormError, validBlank, validMaxNum, validMinNum } from '@/validate';
import { format } from '@/validate/message';

export type DeliveryFormError = {
  baseDeliveryFee: FormError;
  baseDeliveryFeeDistance: FormError;
  additionalDistanceFee: FormError;
  additionalDistance: FormError;
  fixedDiscountAmount: FormError;
  uberDirectCustomerId: FormError;
};

const pattern = /^([0-9]*)$/; // 半角数字を許容する正規表現
export const validateBaseDeliveryFee = (
  newBaseDeliveryFee: string,
  error: DeliveryFormError
): DeliveryFormError => {
  const label = camelOrderDeliveryForm.baseDeliveryFee.label;
  const isBlank = validBlank.check(newBaseDeliveryFee);

  if (isBlank) error.baseDeliveryFee.message = validBlank.message(label);
  const isValidFormat = !pattern.test(newBaseDeliveryFee);

  if (isBlank) error.baseDeliveryFee.message = validBlank.message(label);
  const isValidMin = validMinNum.check(Number(newBaseDeliveryFee), 0);
  if (isValidMin) error.baseDeliveryFee.message = validMinNum.message(label, 0);

  if (isValidFormat) error.baseDeliveryFee.message = format(label);
  error.baseDeliveryFee.isError = isBlank || isValidFormat || isValidMin;
  return error;
};

export const validateBaseDeliveryFeeDistance = (
  newBaseDeliveryFeeDistance: string,
  error: DeliveryFormError
): DeliveryFormError => {
  const label = camelOrderDeliveryForm.baseDeliveryFeeDistance.label;
  const isBlank = validBlank.check(newBaseDeliveryFeeDistance);
  if (isBlank)
    error.baseDeliveryFeeDistance.message = validBlank.message(label);
  const isValidFormat = !pattern.test(newBaseDeliveryFeeDistance);
  if (isValidFormat) error.baseDeliveryFeeDistance.message = format(label);
  error.baseDeliveryFeeDistance.isError = isBlank || isValidFormat;
  return error;
};

export const validateAdditionalDistanceFee = (
  newAdditionalDistanceFee: string,
  error: DeliveryFormError
): DeliveryFormError => {
  const label = camelOrderDeliveryForm.additionalDistanceFee.label;
  const isBlank = validBlank.check(newAdditionalDistanceFee);
  if (isBlank) error.additionalDistanceFee.message = validBlank.message(label);
  const isValidFormat = !pattern.test(newAdditionalDistanceFee);
  if (isValidFormat) error.additionalDistanceFee.message = format(label);
  error.additionalDistanceFee.isError = isBlank || isValidFormat;
  return error;
};

export const validateAdditionalDistance = (
  newAdditionalDistance: string,
  error: DeliveryFormError
): DeliveryFormError => {
  const label = camelOrderDeliveryForm.additionalDistance.label;
  const isBlank = validBlank.check(newAdditionalDistance);
  if (isBlank) error.additionalDistance.message = validBlank.message(label);
  const pattern = /^(?!0\d)([0-9]+(?:\.[0-9]{1,3})?)$/;
  const isValidFormat = !pattern.test(newAdditionalDistance);
  if (isValidFormat) {
    error.additionalDistance.message =
      label + 'は小数点3桁までの半角数字で入力してください。';
  }
  error.additionalDistance.isError = isBlank || isValidFormat;
  return error;
};

export const validateFixedDiscountAmount = (
  newFixedDiscountAmount: string,
  minDeliveryFee: number,
  error: DeliveryFormError
): DeliveryFormError => {
  const label = camelOrderDeliveryForm.fixedDiscountAmount.label;

  const isBlank = validBlank.check(newFixedDiscountAmount);
  if (isBlank) error.fixedDiscountAmount.message = validBlank.message(label);

  const isInValidFormat = !pattern.test(newFixedDiscountAmount);
  if (isInValidFormat) error.fixedDiscountAmount.message = format(label);

  const isBelowMin = validMinNum.check(Number(newFixedDiscountAmount), 1);
  if (isBelowMin)
    error.fixedDiscountAmount.message = validMinNum.message(label, 1);

  const isAboveMax = validMaxNum.check(
    Number(newFixedDiscountAmount),
    minDeliveryFee
  );
  if (isAboveMax)
    error.fixedDiscountAmount.message = `下限の配送料を超える金額は設定できません`;

  error.fixedDiscountAmount.isError =
    isBlank || isInValidFormat || isBelowMin || isAboveMax;
  return error;
};

export const validateUberDirectCustomerId = (
  newUberDirectCustomerId: string,
  error: DeliveryFormError
): DeliveryFormError => {
  const label = camelOrderDeliveryForm.uberDirectCustomerId.label;
  const isBlank = validBlank.check(newUberDirectCustomerId);
  if (isBlank) error.uberDirectCustomerId.message = validBlank.message(label);
  error.uberDirectCustomerId.isError = isBlank;
  return error;
};
